import { api } from "constants/RotasAPI";
import useDelete from "hooks/useDelete";
import toast from "react-hot-toast";

export const useDeleteAssinanteDocumento = () => {
  const onSuccess = () => {
    // toast.success("Assinante excluído com sucesso.");
  };
  return useDelete<number>({
    url: api.groupsign.assinanteDocumento,
    onSuccess,
  });
};
